import React, { useState, useEffect, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepContent from '@material-ui/core/StepContent';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Dialogs from '../../Dialog/Dialogs'
import Formulario from '../NuevoCliente/Formulario'
import Formulario1 from '../NuevoCliente/Formulario1'
import Formulario2 from '../NuevoCliente/Formulario2'
import Formulario3 from '../NuevoCliente/Formulario3'
import ClienteFinal from '../NuevoCliente/ClienteFinal'
import ClienteContext from '../../../context/cliente/clienteContext';
import UsuarioContext from "../../../context/usuario/usuarioContext";
import {Grid} from "@material-ui/core";
import TextField from '@material-ui/core/TextField';
import Titulo from '../../Titulo'

const useStyles = makeStyles((theme) => ({
    root: {
        position: "relative",
        width: "100%",
        height: "100%",
    },
    button: {
        marginTop: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
    actionsContainer: {
        marginBottom: theme.spacing(2),
    },
    resetContainer: {
        padding: theme.spacing(3),
    },
}));

function getSteps() {
    return ['Datos del Cliente', 'Datos de Residencia', 'Datos del Usuario', 'ClienteFinal'];
    }
function GenerarContenido({step,handleNext, handleBack, errorCliente, grabarCliente,cliente }) {
    switch (step) {
    case 0:
        return <Formulario errorCliente={errorCliente}  handleNext={handleNext} handleBack={handleBack} cliente={cliente}/>; 
    case 1:
        return <Formulario2 errorCliente={errorCliente}  handleNext={handleNext} handleBack={handleBack} cliente={cliente}/>;
    case 2:
        return <Formulario3 errorCliente={errorCliente}  handleNext={handleNext} handleBack={handleBack} cliente={cliente}/>;
    case 3:
        return <Formulario1 errorCliente={errorCliente}  handleNext={handleNext} handleBack={handleBack} cliente={cliente}/>;
    default:
        return <Formulario errorCliente={errorCliente}  handleNext={handleNext} handleBack={handleBack} cliente={cliente}/>; 
    }
}

export default function PopUp({ handleClose, init, errorCliente, alerta }) {
    const classes = useStyles();
    const [activeStep, setActiveStep] = React.useState(0);
    const steps = getSteps();
    const [open, setOpen]=useState(true);
    const clienteContext = useContext(ClienteContext);
    const {agregarCliente } = clienteContext;
    const usuarioContext = useContext(UsuarioContext);
    const {
        mensaje,
        obtenerUsuarios,
        agregarUsuario,
        errorUsuario,
        clearErrorUsuario,
        clearOkUsuario,
    } = usuarioContext;
    const [cliente, setCliente]=useState(" ")
    const grabarCliente = () =>{return }
    const limpiarCliente = () => {
        setCliente({ 
            cuit: "",
            razonSocial: "",
            direccion:"",
            localidad:"",
            telefono:"",
            email: "",
            password: "",
            nombre: "",
            rol: "",
            codigoPais: "+549",
            codigoArea: "",
            numeroTelefono:"",
        })
    }
    const validarCuit = (cuit) => {
        let validado = cuit.split(" - ")
        let completo = validado[0]+validado[1]+validado[2]
        return completo
    }
    const finalizar=()=>{
        agregarCliente({
            cuit: validarCuit(cliente.cuit),
            razonSocial: cliente.razonSocial,
            pais: cliente.pais,
            provincia: cliente.provincia,
            direccion: cliente.direccion,
            nombreLocalidad: cliente.nombreLocalidad,
            nombrePais: cliente.nombrePais,
            nombreProvincia: cliente.nombreProvincia,
            localidad: cliente.localidad,
            telefonosCliente:cliente.telefono,
            email: cliente.email,
            password: cliente.password,
            nombre: cliente.nombre,
            rol: cliente.rol,
            telefonoUsuario:{ 
                codigoPais: cliente.codigoPais,
                codigoArea: cliente.codigoArea,
                numeroTelefono: cliente.numeroTelefono
            }
        }
    );
        handleReset();
        init();
        handleClose();
    }
    const otro=()=>{
        agregarCliente(cliente);
        setActiveStep(0);
        limpiarCliente();
        init();
    }

    const handleNext = (cli) => {
        setCliente({ 
            ...cliente,
            cuit: cli.cuit ? cli.cuit : cliente.cuit,
            razonSocial: cli.razonSocial ? cli.razonSocial : cliente.razonSocial,
            pais: cli.pais ? cli.pais : cliente.pais,
            provincia:cli.provincia ? cli.provincia : cliente.provincia,
            direccion: cli.direccion ? cli.direccion : cliente.direccion,
            nombreLocalidad: cli.localidadNombre ? cli.localidadNombre : cliente.nombreLocalidad,
            nombrePais: cli.paisNombre ? cli.paisNombre : cliente.nombrePais,
            nombreProvincia: cli.provinciaNombre ? cli.provinciaNombre : cliente.nombreProvincia,
            localidad: cli.localidad ? cli.localidad : cliente.localidad,
            telefono: cli.telefono ? cli.telefono : cliente.telefono,
            email: cli.email ? cli.email : cliente.email,
            password: cli.password ? cli.password : cliente.password,
            nombre: cli.nombre ? cli.nombre : cliente.nombre,
            rol: cli.rol ? cli.rol : cliente.rol,
            codigoPais: cli.codigoPais ? cli.codigoPais : cliente.codigoPais,
            codigoArea: cli.codigoArea ? (cli.codigoArea===cliente.codigoArea) ? cliente.codigoArea : cli.codigoArea.slice(1,5) : cliente.codigoArea,
            numeroTelefono: cli.numeroTelefono ? (cli.numeroTelefono===cliente.numeroTelefono) ? cliente.numeroTelefono : cli.numeroTelefono.slice(2, 10) : cliente.numeroTelefono,
        })
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };
    const handleReset = () => {
        setActiveStep(0);
    };
return (
    <div className={classes.root}>
        {activeStep === steps.length ? (
            <div>
                <ClienteFinal errorCliente={errorCliente} otro={otro} finalizar={finalizar}  handleNext={handleNext} handleBack={handleBack} cliente={cliente} alerta={alerta}/>
            </div>
        ) : (
            <div>
                <GenerarContenido 
                    step={activeStep} 
                    handleNext={handleNext}
                    handleBack={handleBack}
                    errorCliente ={errorCliente}
                    cliente={cliente}
                />
            </div>
        )}
        </div>
    )
}
